
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ImageSample from "@/components/common/ImageSampleNew.vue";
  import EnlargedImageViewer from "@/components/common/EnlargedImageViewer.vue";
  // @ts-ignore: Unreachable code error
  import { Carousel, Slide } from "vue-carousel";
  import storage from '@/services/storage';

  @Component({
    components: {
      ImageSample,
      Carousel,
      Slide,
      EnlargedImageViewer,
    },
  })
  export default class Slider extends Vue {
    @Prop({ type: Array, required: true }) readonly items!: string[];
    @Prop({ type: Number, default: 7000 }) readonly autoplayTimeout!: number;

    imagesLinks: string[] = [];
    index: number = 0;
    lightboxVisible: boolean = false;

    autoplay = true;

    async mounted() {
      this.imagesLinks = await this.getImageUrls();
    }

    async _getFile(sample:string): Promise<string> {
      return await storage.get(sample) as string;
    }

    async getImageUrls(): Promise<string[]> {
      const imagePromises = this.items.map(async sample => await this._getFile(sample));
      return await Promise.all(imagePromises);
    }

    stopAutoplay() {
      this.autoplay = false;
    }

    handleHide() {
      this.lightboxVisible = false;
    }

    showImg (i: number) {
      this.index = i;
      this.lightboxVisible = true;
    }
  }
